import { createContext } from 'react';

export const FollowingActivityStatsContext = createContext(null);

export function buildFollowingActivityStatsMap(rows) {
  return rows.reduce((map, row) => {
    map[String(row.account.id)] = {
      posts_per_day: row.posts_per_day,
      statuses_count_30d: row.statuses_count_30d,
    };
    return map;
  }, {});
}
